var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2025_6597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.405638 15.1056C-0.443106 11.9051 0.0724062 8.65996 1.59199 6.00056C3.11158 3.34115 5.63524 1.26746 8.80279 0.409881C15.1379 -1.30528 21.6496 2.4934 23.3471 8.89446C23.5593 9.69459 23.0893 10.517 22.2975 10.7314C21.5056 10.9458 20.6916 10.471 20.4794 9.67085C19.2063 4.87005 14.3225 2.02105 9.57119 3.30742C7.19552 3.9506 5.30278 5.50588 4.16309 7.50043C3.0234 9.49498 2.63676 11.9288 3.27332 14.3292C4.54644 19.13 9.43022 21.979 14.1815 20.6927C14.9734 20.4783 15.7874 20.9531 15.9996 21.7532C16.2118 22.5534 15.7418 23.3758 14.9499 23.5902C8.61483 25.3054 2.10313 21.5067 0.405638 15.1056Z",
    fill: "#2D2926"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2025_6597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpinner);
export default __webpack_public_path__ + "static/media/iconSpinner.3a2aaf0e147c0d7904590872904226e9.svg";
export { ForwardRef as ReactComponent };